(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["date-time-picker-one"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const dateTimeForms = document.querySelectorAll('.date-time-picker-form');
    
    // 创建并添加进度条容器到body
    function createProgressContainer() {
      const container = document.createElement('div');
      container.id = 'progress-container';
      container.className = 'progress-container';
      container.style.display = 'none';
      container.innerHTML = `
        <div class="progress-overlay">
          <div class="progress-content">
            <h3>正在处理您的请求...</h3>
            <div class="progress-bar-container">
              <div class="progress-bar"></div>
            </div>
            <p class="progress-text">请稍候，这可能需要几秒钟时间</p>
          </div>
        </div>
      `;
      document.body.appendChild(container);
      return container;
    }
    
    const progressContainer = createProgressContainer();
    
    // 创建并显示页面内结果的函数
    function showResultInPage(form, htmlContent) {
      // 安全处理HTML内容，避免加载不存在的服务器资源
      const safeHtmlContent = htmlContent || '<p>暂无返回内容</p>';
      
      // 查找或创建结果容器
      let resultContainer = form.nextElementSibling;
      if (!resultContainer || !resultContainer.classList.contains('date-time-result-container')) {
        resultContainer = document.createElement('div');
        resultContainer.className = 'date-time-result-container';
        form.parentNode.insertBefore(resultContainer, form.nextSibling);
      }
      
      // 设置结果容器内容
      resultContainer.innerHTML = `
        <div class="result-container">
          <div class="result-header">
            <h2>处理完成</h2>
            <button class="close-button">关闭</button>
          </div>
          <div class="result-content">
            ${safeHtmlContent}
          </div>
        </div>
      `;
      
      // 添加关闭按钮事件
      const closeButton = resultContainer.querySelector('.close-button');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          resultContainer.style.display = 'none';
        });
      }
      
      // 捕获资源加载错误，避免显示服务器连接错误
      const resultContent = resultContainer.querySelector('.result-content');
      resultContent.addEventListener('error', function(e) {
        // 忽略资源加载错误，不阻止页面显示
        e.preventDefault();
        console.warn('资源加载失败，但不影响页面显示:', e.target);
      }, true);
      
      // 显示结果容器
      resultContainer.style.display = 'block';
      
      // 滚动到结果区域
      resultContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      
      return resultContainer;
    }
    
    // 模拟进度条动画 - 调整为90秒完成
    function animateProgress() {
      const progressBar = document.querySelector('.progress-bar');
      let width = 0;
      // 目标：90秒内进度达到90%
      // 计算每100毫秒应该增加的宽度
      const totalDuration = 90000; // 90秒
      const intervalDuration = 100; // 每次更新间隔100毫秒
      const steps = totalDuration / intervalDuration;
      const baseIncrement = 90 / steps;
      
      const interval = setInterval(function() {
        if (width >= 90) { // 不达到100%，等待实际响应
          clearInterval(interval);
        } else {
          // 使用基础增量加上小的随机值，使进度条更自然
          width += baseIncrement + (Math.random() * baseIncrement * 0.5);
          if (width > 90) width = 90;
          progressBar.style.width = width + '%';
        }
      }, intervalDuration);
      
      return interval;
    }
    
    // ReportType变量已添加到schema中，会自动包含在表单提交数据中
    
    dateTimeForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        // 不需要用户登录即可使用该功能
          // 用户已登录，获取选择的日期和时间
          const selectedDate = this.querySelector('.selected-date').value;
          const selectedTime = this.querySelector('.selected-time').value;
          
          // 合并日期和时间为一个字段
          const datetime = `${selectedDate}T${selectedTime}:00`;
          
          // 获取用户选择的报告类型
          const reportType = this.querySelector('.report-type').value;
          
          // 获取地址信息
          const country = this.querySelector('.country-input').value;
          const state = this.querySelector('.state-input').value;
          const city = this.querySelector('.city-input').value;
          
          // 合并地址信息为一个字符串
          const address = `${country}, ${state}, ${city}`;
          
          // 构建数据
          const formData = {
            datetime: datetime,
            reportType: reportType,
            address: address
          };
          
          // 显示进度条
          progressContainer.style.display = 'block';
          const progressInterval = animateProgress();
          
          // 实际发送请求到webhook地址
          fetch('https://hook.us2.make.com/7v43fu1ybxkae5ye5btysgupo5j02vhr', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            // 完成进度条
            clearInterval(progressInterval);
            const progressBar = document.querySelector('.progress-bar');
            progressBar.style.width = '100%';
            
            if (!response.ok) {
              throw new Error('网络响应异常: ' + response.status);
            }
            
            // 尝试解析响应为JSON
            return response.json().catch(() => {
              // 如果响应不是有效的JSON，返回成功消息
              return { success: true, message: '请求已成功发送' };
            });
          })
          .then(data => {
            // 短暂延迟后隐藏进度条并显示结果
            setTimeout(() => {
              progressContainer.style.display = 'none';
              
              // 处理嵌套的JSON响应结构
              let outputContent = '';
              if (data && data.Output) {
                try {
                  // 如果Output是字符串，尝试解析为JSON
                  const outputJson = typeof data.Output === 'string' ? JSON.parse(data.Output) : data.Output;
                  if (outputJson && outputJson.output) {
                    outputContent = outputJson.output;
                  }
                } catch (e) {
                  console.error('解析Output字段失败:', e);
                  outputContent = data.Output; // 如果解析失败，直接使用原始内容
                }
              } else if (data && data.output) {
                // 保持原有的处理逻辑作为备选
                outputContent = data.output;
              }
              
              // 根据返回的数据创建结果HTML内容
              const resultHtml = `
                <div class="result-container">
                  <h2>处理完成</h2>
                  <div class="result-details">
                    <p><strong>选择的日期时间:</strong> ${formData.datetime}</p>
                    <p><strong>报告类型:</strong> ${formData.reportType}</p>
                    <p><strong>地址信息:</strong> ${formData.address}</p>
                    <p><strong>处理时间:</strong> ${new Date().toLocaleString()}</p>
                    <p><strong>响应状态:</strong> ${data.success ? '成功' : '失败'}</p>
                  </div>
                  <div class="result-message">
                    <p>${data.message || '您的请求已成功处理！'}</p>
                  </div>
                  ${outputContent ? `
                  <div class="output-data">
                    <h3>返回结果内容:</h3>
                    <div class="output-content">${typeof outputContent === 'object' ? JSON.stringify(outputContent, null, 2) : outputContent}</div>
                  </div>
                  ` : ''}
                  ${data.responseData || data.Output ? `
                  <div class="response-data">
                    <h3>返回数据详情:</h3>
                    <pre>${JSON.stringify(data.responseData || data.Output, null, 2)}</pre>
                  </div>
                  ` : ''}
                </div>
                <style>
                  .result-details {
                    background-color: #f8f9fa;
                    padding: 15px;
                    border-radius: 5px;
                    margin: 20px 0;
                  }
                  .result-message {
                    background-color: #e8f5e9;
                    padding: 15px;
                    border-radius: 5px;
                    border-left: 4px solid #4caf50;
                  }
                  .response-data {
                    background-color: #e3f2fd;
                    padding: 15px;
                    border-radius: 5px;
                    margin-top: 20px;
                  }
                  .response-data pre {
                    background-color: #f5f5f5;
                    padding: 10px;
                    border-radius: 4px;
                    overflow-x: auto;
                    font-size: 14px;
                  }
                  .output-data {
                    background-color: #fff3e0;
                    padding: 15px;
                    border-radius: 5px;
                    margin-top: 20px;
                  }
                  .output-content {
                    background-color: white;
                    padding: 15px;
                    border-radius: 4px;
                    border: 1px solid #ffcc80;
                    line-height: 1.6;
                  }
                </style>
              `;
              
              // 在当前页面显示结果
              showResultInPage(form, resultHtml);
            }, 500);
          })
          .catch(error => {
            // 错误处理
            clearInterval(progressInterval);
            
            setTimeout(() => {
              progressContainer.style.display = 'none';
              
              const errorHtml = `
                <div class="result-container">
                  <h2>处理失败</h2>
                  <div class="error-details">
                    <p><strong>错误信息:</strong> ${error.message}</p>
                    <p><strong>选择的日期时间:</strong> ${formData.datetime}</p>
                    <p><strong>报告类型:</strong> ${formData.reportType}</p>
                    <p><strong>地址信息:</strong> ${formData.address}</p>
                    <p><strong>请求数据:</strong> ${JSON.stringify(formData)}</p>
                  </div>
                  <div class="error-message">
                    <p>很抱歉，请求处理过程中发生错误。请稍后重试。</p>
                  </div>
                </div>
                <style>
                  .error-details {
                    background-color: #fdf2e9;
                    padding: 15px;
                    border-radius: 5px;
                    margin: 20px 0;
                  }
                  .error-message {
                    background-color: #ffebee;
                    padding: 15px;
                    border-radius: 5px;
                    border-left: 4px solid #f44336;
                  }
                </style>
              `;
              
              showResultInPage(form, errorHtml);
            }, 500);
          });

      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["date-time-picker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const dateTimeForms = document.querySelectorAll('.date-time-picker-form');
    
    // 获取用户信息的函数
    function getUserInfo() {
      // 尝试从meta标签获取用户信息
      const userInfoMeta = document.querySelector('meta[name="user-info"]');
      if (userInfoMeta) {
        try {
          return JSON.parse(userInfoMeta.getAttribute('content'));
        } catch (e) {
          console.warn('解析用户信息失败:', e);
        }
      }
      
      // 返回默认值
      return {
        userId: null,
        email: null,
        isLoggedIn: false
      };
    };
    
    // 创建并添加进度条容器到body
    function createProgressContainer() {
      const container = document.createElement('div');
      container.id = 'progress-container';
      container.className = 'progress-container';
      container.style.display = 'none';
      container.innerHTML = `
        <div class="progress-overlay">
          <div class="progress-content">
            <h3>正在处理您的请求...</h3>
            <div class="progress-bar-container">
              <div class="progress-bar"></div>
            </div>
            <p class="progress-text">请稍候，这可能需要几秒钟时间</p>
          </div>
        </div>
      `;
      document.body.appendChild(container);
      return container;
    }
    
    const progressContainer = createProgressContainer();
    
    // 创建并显示页面内结果的函数
    function showResultInPage(form, htmlContent) {
      // 安全处理HTML内容，避免加载不存在的服务器资源
      const safeHtmlContent = htmlContent || '<p>暂无返回内容</p>';
      
      // 查找或创建结果容器
      let resultContainer = form.nextElementSibling;
      if (!resultContainer || !resultContainer.classList.contains('date-time-result-container')) {
        resultContainer = document.createElement('div');
        resultContainer.className = 'date-time-result-container';
        form.parentNode.insertBefore(resultContainer, form.nextSibling);
      }
      
      // 设置结果容器内容
      resultContainer.innerHTML = `
        <div class="result-container">
          <div class="result-header">
            <h2>处理完成</h2>
            <button class="close-button">关闭</button>
          </div>
          <div class="result-content">
            ${safeHtmlContent}
          </div>
        </div>
      `;
      
      // 添加关闭按钮事件
      const closeButton = resultContainer.querySelector('.close-button');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          resultContainer.style.display = 'none';
        });
      }
      
      // 捕获资源加载错误，避免显示服务器连接错误
      const resultContent = resultContainer.querySelector('.result-content');
      resultContent.addEventListener('error', function(e) {
        // 忽略资源加载错误，不阻止页面显示
        e.preventDefault();
        console.warn('资源加载失败，但不影响页面显示:', e.target);
      }, true);
      
      // 显示结果容器
      resultContainer.style.display = 'block';
      
      // 滚动到结果区域
      resultContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      
      return resultContainer;
    }
    
    // 模拟进度条动画 - 调整为90秒完成
    function animateProgress() {
      const progressBar = document.querySelector('.progress-bar');
      let width = 0;
      // 目标：90秒内进度达到90%
      // 计算每100毫秒应该增加的宽度
      const totalDuration = 90000; // 90秒
      const intervalDuration = 100; // 每次更新间隔100毫秒
      const steps = totalDuration / intervalDuration;
      const baseIncrement = 90 / steps;
      
      const interval = setInterval(function() {
        if (width >= 90) { // 不达到100%，等待实际响应
          clearInterval(interval);
        } else {
          // 使用基础增量加上小的随机值，使进度条更自然
          width += baseIncrement + (Math.random() * baseIncrement * 0.5);
          if (width > 90) width = 90;
          progressBar.style.width = width + '%';
        }
      }, intervalDuration);
      
      return interval;
    }
    
    // 用户信息获取功能已保留，将在表单提交时自动包含用户ID信息
    
    // ReportType变量已添加到schema中，会自动包含在表单提交数据中
    
    dateTimeForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        // 不需要用户登录即可使用该功能
          // 用户已登录，获取选择的日期和时间
          const selectedDate = this.querySelector('.selected-date').value;
          const selectedTime = this.querySelector('.selected-time').value;
          
          // 合并日期和时间为一个字段
          const datetime = `${selectedDate}T${selectedTime}:00`;
          
          // 获取用户选择的报告类型
          const reportType = this.querySelector('.report-type').value;
          
          // 获取地址信息
          const country = this.querySelector('.country-input').value;
          const state = this.querySelector('.state-input').value;
          const city = this.querySelector('.city-input').value;
          
          // 合并地址信息为一个字符串
          const address = `${country}, ${state}, ${city}`;
          
          // 获取用户信息
          const userInfo = getUserInfo();
          
          // 构建数据，包含用户信息
          const formData = {
            datetime: datetime,
            reportType: reportType,
            address: address,
            userId: String(userInfo.userId)
          };
          
          // 显示进度条
          progressContainer.style.display = 'block';
          const progressInterval = animateProgress();
          
          // 实际发送请求到webhook地址
          fetch('https://hook.us2.make.com/4xw7pc3q5g8akcmusor7rgflij5pvpa8', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            // 完成进度条
            clearInterval(progressInterval);
            const progressBar = document.querySelector('.progress-bar');
            progressBar.style.width = '100%';
            
            if (!response.ok) {
              throw new Error('网络响应异常: ' + response.status);
            }
            
            // 尝试解析响应为JSON
            return response.json().catch(() => {
              // 如果响应不是有效的JSON，返回成功消息
              return { success: true, message: '请求已成功发送' };
            });
          })
          .then(data => {
            // 短暂延迟后隐藏进度条
            setTimeout(() => {
              progressContainer.style.display = 'none';
              
              // 检查返回数据类型
              if (data && data.type) {
                // 第一种情况：直接跳转到URL
                if (data.type === 'url' && data.data) {
                  // 提取URL并跳转，移除可能的反引号
                  const url = data.data.replace(/^`|`$/g, '').trim();
                  window.location.href = url;
                  return;
                }
              }
              
              // 第二种情况及其他：保持现有处理方法不变
              // 处理嵌套的JSON响应结构
              let outputContent = '';
              if (data && data.Output) {
                try {
                  // 如果Output是字符串，尝试解析为JSON
                  const outputJson = typeof data.Output === 'string' ? JSON.parse(data.Output) : data.Output;
                  if (outputJson && outputJson.output) {
                    outputContent = outputJson.output;
                  }
                } catch (e) {
                  console.error('解析Output字段失败:', e);
                  outputContent = data.Output; // 如果解析失败，直接使用原始内容
                }
              } else if (data && data.output) {
                // 保持原有的处理逻辑作为备选
                outputContent = data.output;
              } else if (data && data.type === 'report' && data.data) {
                // 新增：处理report类型的数据
                outputContent = data.data;
              }
              
              // 根据返回的数据创建结果HTML内容
              const resultHtml = `
                <div class="result-container">
                  <h2>处理完成</h2>
                  <div class="result-details">
                    <p><strong>选择的日期时间:</strong> ${formData.datetime}</p>
                    <p><strong>报告类型:</strong> ${formData.reportType}</p>
                    <p><strong>地址信息:</strong> ${formData.address}</p>
                    <p><strong>处理时间:</strong> ${new Date().toLocaleString()}</p>
                  </div>
                  <div class="result-message">
                    <p>${data.message || '您的请求已成功处理！'}</p>
                  </div>
                  ${outputContent ? `
                  <div class="output-data">
                    <h3>返回结果内容:</h3>
                    <div class="output-content">${typeof outputContent === 'object' ? JSON.stringify(outputContent, null, 2) : outputContent}</div>
                  </div>
                  ` : ''}
                  ${data.responseData || data ? `
                  <div class="response-data">
                    <h3>返回数据详情:</h3>
                    <pre>${JSON.stringify(data.responseData || data, null, 2)}</pre>
                  </div>
                  ` : ''}
                </div>
                <style>
                  .result-details {
                    background-color: #f8f9fa;
                    padding: 15px;
                    border-radius: 5px;
                    margin: 20px 0;
                  }
                  .result-message {
                    background-color: #e8f5e9;
                    padding: 15px;
                    border-radius: 5px;
                    border-left: 4px solid #4caf50;
                  }
                  .response-data {
                    background-color: #e3f2fd;
                    padding: 15px;
                    border-radius: 5px;
                    margin-top: 20px;
                  }
                  .response-data pre {
                    background-color: #f5f5f5;
                    padding: 10px;
                    border-radius: 4px;
                    overflow-x: auto;
                    font-size: 14px;
                  }
                  .output-data {
                    background-color: #fff3e0;
                    padding: 15px;
                    border-radius: 5px;
                    margin-top: 20px;
                  }
                  .output-content {
                    background-color: white;
                    padding: 15px;
                    border-radius: 4px;
                    border: 1px solid #ffcc80;
                    line-height: 1.6;
                  }
                </style>
              `;
              
              // 在当前页面显示结果
              showResultInPage(form, resultHtml);
            }, 500);
          })
          .catch(error => {
            // 错误处理
            clearInterval(progressInterval);
            
            setTimeout(() => {
              progressContainer.style.display = 'none';
              
              const errorHtml = `
                <div class="result-container">
                  <h2>处理失败</h2>
                  <div class="error-details">
                    <p><strong>错误信息:</strong> ${error.message}</p>
                    <p><strong>选择的日期时间:</strong> ${formData.datetime}</p>
                    <p><strong>报告类型:</strong> ${formData.reportType}</p>
                    <p><strong>地址信息:</strong> ${formData.address}</p>
                    <p><strong>请求数据:</strong> ${JSON.stringify(formData)}</p>
                  </div>
                  <div class="error-message">
                    <p>很抱歉，请求处理过程中发生错误。请稍后重试。</p>
                  </div>
                </div>
                <style>
                  .error-details {
                    background-color: #fdf2e9;
                    padding: 15px;
                    border-radius: 5px;
                    margin: 20px 0;
                  }
                  .error-message {
                    background-color: #ffebee;
                    padding: 15px;
                    border-radius: 5px;
                    border-left: 4px solid #f44336;
                  }
                </style>
              `;
              
              showResultInPage(form, errorHtml);
            }, 500);
          });

      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
  jQuery(document).ready(function($) {
    $('.btn-close').on('click', function() {
      $(this).parents('.parent-close').slideUp();
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-id-popup"] && !Shopify.designMode) return;
  try {
    
// 获取DOM元素
const showUserIdBtn = document.getElementById('show-user-id-btn');
const modal = document.getElementById('user-id-modal');
const closeBtn = document.getElementsByClassName('user-id-close')[0];

// 显示弹窗的函数
function showModal() {
  modal.style.display = 'flex';
}

// 隐藏弹窗的函数
function hideModal() {
  modal.style.display = 'none';
}

// 点击按钮显示弹窗
if (showUserIdBtn) {
  showUserIdBtn.addEventListener('click', showModal);
}

// 点击关闭按钮隐藏弹窗
if (closeBtn) {
  closeBtn.addEventListener('click', hideModal);
}

// 点击弹窗外的区域隐藏弹窗
window.addEventListener('click', function(event) {
  if (event.target === modal) {
    hideModal();
  }
});

// 按ESC键隐藏弹窗
window.addEventListener('keydown', function(event) {
  if (event.key === 'Escape' && modal.style.display === 'flex') {
    hideModal();
  }
});

  } catch(e) { console.error(e); }
})();
})();
